<template>
  <router-view :key="$route.fullPath"></router-view>
</template>
<script>
export default {
  name: "template"
};
</script>



// WEBPACK FOOTER //
// src/views/Layout/template.vue